export class ApiRoutes {
  // GovexProfile endpoints
  static get REST_API_GOVEXPROFILE_ENDPOINT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/govex-profile';
  }

  static get REST_API_GOVEXPROFILE_SEARCH(): string {
    return this.REST_API_GOVEXPROFILE_ENDPOINT + '/search';
  }

  static get REST_API_GOVEXPROFILE_CREATE(): string {
    return this.REST_API_GOVEXPROFILE_ENDPOINT + '/create';
  }

  // Govex dashboard (REGOBO-44) — aggregated read-only payload for /dashboard
  static get REST_API_GOVEX_DASHBOARD_ENDPOINT(): string {
    return `${this.APP_API_URL_BACKEND()}/v1/rest-api/govex-dashboard`;
  }

  // Shared memo (userref=1) — read for all, write for the ADMIN department (REGOBO-44)
  static get REST_API_MEMO_ENDPOINT(): string {
    return `${this.APP_API_URL_BACKEND()}/v1/rest-api/memo`;
  }

  // GovexMonthlyTargets endpoints (REBO-872)
  static get REST_API_GOVEX_MONTHLY_TARGETS_ENDPOINT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/govex-monthly-targets';
  }

  static get REST_API_GOVEX_MONTHLY_TARGETS_CALENDAR_ENDPOINT(): string {
    return this.REST_API_GOVEX_MONTHLY_TARGETS_ENDPOINT + '/calendar';
  }

  // GovexInvoicesByVendor endpoints (REBO-872)
  static get REST_API_GOVEX_INVOICES_BY_VENDOR_ENDPOINT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/govex-invoices-by-vendor';
  }

  static get REST_API_GOVEX_INVOICES_BY_VENDOR_SEARCH(): string {
    return this.REST_API_GOVEX_INVOICES_BY_VENDOR_ENDPOINT + '/search';
  }

  static get REST_API_GOVEX_INVOICES_BY_VENDOR_TOTAL(): string {
    return this.REST_API_GOVEX_INVOICES_BY_VENDOR_ENDPOINT + '/total';
  }

  // AssignationSalesTeasing endpoints (BOB-229) — Govex teasing awaiting test abo listing
  static get REST_API_TEASING_AWAITING_TEST_ABO_ENDPOINT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/teasing-awaiting-test-abo';
  }

  static get REST_API_TEASING_AWAITING_TEST_ABO_SEARCH(): string {
    return this.REST_API_TEASING_AWAITING_TEST_ABO_ENDPOINT + '/search';
  }

  // GovexPaymentsDashboard endpoints
  static get REST_API_GOVEX_PAYMENTS_DASHBOARD_ENDPOINT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/govex-payments-dashboard';
  }

  static get REST_API_GOVEX_PAYMENTS_SALES_BY_PAYMENTS_MONTHLY(): string {
    return this.REST_API_GOVEX_PAYMENTS_DASHBOARD_ENDPOINT + '/sales-by-payments/monthly';
  }

  static get REST_API_GOVEX_PAYMENTS_SALES_BY_PAYMENTS_QUARTERLY(): string {
    return this.REST_API_GOVEX_PAYMENTS_DASHBOARD_ENDPOINT + '/sales-by-payments/quarterly';
  }

  static get REST_API_GOVEX_PAYMENTS_SALES_BY_PAYMENTS_YEARLY(): string {
    return this.REST_API_GOVEX_PAYMENTS_DASHBOARD_ENDPOINT + '/sales-by-payments/yearly';
  }

  static get REST_API_GOVEX_PAYMENTS_PAYMENT_DAYS(): string {
    return this.REST_API_GOVEX_PAYMENTS_DASHBOARD_ENDPOINT + '/payment-days';
  }

  // GovexLawyerDashboard endpoints
  static get REST_API_GOVEX_LAWYER_DASHBOARD_ENDPOINT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/govex-lawyer-dashboard';
  }

  static get REST_API_GOVEX_LAWYER_DASHBOARD_STATUS(): string {
    return this.REST_API_GOVEX_LAWYER_DASHBOARD_ENDPOINT + '/status';
  }

  static get REST_API_GOVEX_LAWYER_DASHBOARD_END_REASON(): string {
    return this.REST_API_GOVEX_LAWYER_DASHBOARD_ENDPOINT + '/end-reason';
  }

  static get REST_API_GOVEX_LAWYER_DASHBOARD_CREDIT_NOTES(): string {
    return this.REST_API_GOVEX_LAWYER_DASHBOARD_ENDPOINT + '/credit-notes';
  }

  static get REST_API_GOVEX_LAWYER_DASHBOARD_BANKRUPTCIES(): string {
    return this.REST_API_GOVEX_LAWYER_DASHBOARD_ENDPOINT + '/bankruptcies';
  }

  static get REST_API_GOVEX_LAWYER_DASHBOARD_BANKRUPTCIES_BY_STOP_DATE(): string {
    return this.REST_API_GOVEX_LAWYER_DASHBOARD_ENDPOINT + '/bankruptcies-by-stop-date';
  }

  // GovexInvoiceVsPaid endpoint
  static get REST_API_GOVEX_INVOICE_VS_PAID(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/govex-invoice-vs-paid';
  }

  // GovexMember endpoints
  static get REST_API_GOVEX_MEMBER_ENDPOINT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/govex-member';
  }

  static get REST_API_GOVEX_MEMBER_SEARCH(): string {
    return this.REST_API_GOVEX_MEMBER_ENDPOINT + '/search';
  }

  static REST_API_GOVEX_MEMBER_EXTRANET_LOGIN(id: number): string {
    return this.REST_API_GOVEX_MEMBER_ENDPOINT + '/' + id + '/extranet-login';
  }

  // GovexSubscription endpoints
  static get REST_API_GOVEXSUBSCRIPTION_ENDPOINT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/govex-subscription';
  }

  static get REST_API_GOVEXSUBSCRIPTION_SEARCH(): string {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/search';
  }

  static get REST_API_GOVEXSUBSCRIPTION_SEARCH_RENEWALS(): string {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/search-renewals';
  }

  static REST_API_GOVEXSUBSCRIPTION_RENEWALS_YEAR_MONTHS = (testAbo: boolean): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/renewals/year-months?testAbo=' + testAbo;
  };

  static get REST_API_GOVEXSUBSCRIPTION_CREATE(): string {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/create';
  }

  static get REST_API_GOVEXSUBSCRIPTION_SAVE(): string {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/save';
  }

  // GovexSubscriptionLine endpoints
  static get REST_API_GOVEXSUBSCRIPTION_LINE_ENDPOINT(): string {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/line';
  }

  static get REST_API_GOVEXSUBSCRIPTION_LINE_CREATE(): string {
    return this.REST_API_GOVEXSUBSCRIPTION_LINE_ENDPOINT + '/create';
  }

  static APP_API_URL_BACKEND = (): string => {
    const serverName = window.location.hostname;
    let urlSpring: string;

    if (serverName === 'localhost') {
      urlSpring = 'http://localhost:8090';
    }else if (serverName.includes('staging.admin')) {
      urlSpring = 'https://staging.admin.govex.be';
    } else {
      urlSpring = 'https://admin.govex.be';
    }

    urlSpring += '/api-bo-govex';
    return urlSpring;
  };

  static REST_API_GOVEXPROFILE_BY_ID = (profileId: number): string => {
    return this.REST_API_GOVEXPROFILE_ENDPOINT + '/' + profileId;
  };

  static REST_API_GOVEXPROFILE_ACTIVATE = (profileId: number): string => {
    return this.REST_API_GOVEXPROFILE_ENDPOINT + '/' + profileId + '/activate';
  };

  static REST_API_GOVEXPROFILE_DEACTIVATE = (profileId: number): string => {
    return this.REST_API_GOVEXPROFILE_ENDPOINT + '/' + profileId + '/deactivate';
  };

  static REST_API_GOVEXPROFILE_BDAMAILS = (profileId: number): string => {
    return this.REST_API_GOVEXPROFILE_ENDPOINT + '/' + profileId + '/bdamails';
  };

  static REST_API_GOVEXPROFILE_JOUEMAILS = (profileId: number): string => {
    return this.REST_API_GOVEXPROFILE_ENDPOINT + '/' + profileId + '/jouemails';
  };

  static REST_API_GOVEXPROFILE_DETAILEDPROFILE_CREATE = (profileId: number): string => {
    return this.REST_API_GOVEXPROFILE_ENDPOINT + '/' + profileId + '/detailedprofiles/create';
  };

  static REST_API_GOVEXPROFILE_DETAILEDPROFILE_UPDATE = (
    profileId: number,
    detailedProfileId: number
  ): string => {
    return (
      this.REST_API_GOVEXPROFILE_ENDPOINT +
      '/' +
      profileId +
      '/detailedprofiles/' +
      detailedProfileId +
      '/update'
    );
  };

  static REST_API_GOVEXPROFILE_DETAILEDPROFILE_DELETE = (
    profileId: number,
    detailedProfileId: number
  ): string => {
    return (
      this.REST_API_GOVEXPROFILE_ENDPOINT +
      '/' +
      profileId +
      '/detailedprofiles/' +
      detailedProfileId +
      '/delete'
    );
  };

  static get REST_API_GOVEXSUBSCRIPTION_SEARCH_BY_INVOICE_REF(): string {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/search-by-invoice-ref';
  }

  static get REST_API_GOVEXSUBSCRIPTION_SEARCH_INVOICED(): string {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/search-invoiced';
  }

  static REST_API_GOVEXSUBSCRIPTION_BY_ID = (subscriptionId: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + subscriptionId;
  };

  static REST_API_GOVEXSUBSCRIPTION_UPDATE = (id: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + id + '/update';
  };

  static REST_API_GOVEXSUBSCRIPTION_DETAILS = (id: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + id + '/details';
  };

  static REST_API_GOVEXSUBSCRIPTION_DELETE = (id: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + id + '/delete';
  };

  static REST_API_GOVEXSUBSCRIPTION_FINALIZE = (id: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + id + '/finalize';
  };

  static REST_API_GOVEXSUBSCRIPTION_RENEW = (id: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + id + '/renew';
  };

  static REST_API_GOVEXSUBSCRIPTION_SHOW_INVOICE = (id: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + id + '/showInvoice';
  };

  static REST_API_GOVEXSUBSCRIPTION_SEND_EMAIL = (id: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + id + '/send-subscription-email';
  };

  static REST_API_GOVEXSUBSCRIPTION_INVOICE = (subscriptionId: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + subscriptionId + '/invoice';
  };

  static REST_API_GOVEXSUBSCRIPTION_INVOICE_PDF = (subscriptionId: number): string => {
    return (
      this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + subscriptionId + '/download-invoice-pdf'
    );
  };

  static REST_API_GOVEXSUBSCRIPTION_ORDER_FORM = (subscriptionId: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + subscriptionId + '/order-form';
  };

  static REST_API_GOVEXSUBSCRIPTION_ORDER_FORM_PDF = (subscriptionId: number): string => {
    return (
      this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + subscriptionId + '/download-order-form-pdf'
    );
  };

  static REST_API_GOVEXSUBSCRIPTION_INVITATION_DATE = (subscriptionId: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + subscriptionId + '/invitation-date';
  };

  // UBL Subscription endpoints
  static get REST_API_UBL_SUBSCRIPTION_ENDPOINT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/ubl/subscription';
  }

  static REST_API_UBL_SUBSCRIPTION_CREATE = (subscriptionId: number): string => {
    return this.REST_API_UBL_SUBSCRIPTION_ENDPOINT + '/' + subscriptionId + '/create';
  };

  static REACT_APP_URL_GOVEXSUBSCRIPTION_UBL_SEND_RECORDS: string =
    this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/ubl-send-records';

  static REST_API_GOVEXSUBSCRIPTION_LINE_UPDATE = (id: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_LINE_ENDPOINT + '/' + id + '/update';
  };
  static REST_API_GOVEXSUBSCRIPTION_LINE_DELETE = (id: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_LINE_ENDPOINT + '/' + id + '/delete';
  };

  // GovexCredit endpoints
  static REST_API_GOVEXCREDIT_READ = (subscriptionId: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + subscriptionId + '/credit';
  };
  static REST_API_GOVEXCREDIT_CREATE = (subscriptionId: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + subscriptionId + '/credit/create';
  };
  static REST_API_GOVEXCREDIT_UPDATE = (subscriptionId: number, id: number): string => {
    return (
      this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + subscriptionId + '/credit/' + id + '/update'
    );
  };
  static REST_API_GOVEXCREDIT_VIEW_HTML = (subscriptionId: number, creditId: number): string => {
    return (
      this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT +
      '/' +
      subscriptionId +
      '/credit/' +
      creditId +
      '/view-html'
    );
  };
  static REST_API_GOVEXCREDIT_DOWNLOAD_PDF = (subscriptionId: number, creditId: number): string => {
    return (
      this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT +
      '/' +
      subscriptionId +
      '/credit/' +
      creditId +
      '/download-pdf'
    );
  };
  static REST_API_GOVEXCREDIT_SEND_EMAIL = (subscriptionId: number, creditId: number): string => {
    return (
      this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT +
      '/' +
      subscriptionId +
      '/credit/' +
      creditId +
      '/send-email'
    );
  };
  static REST_API_GOVEXCREDIT_SEND_TO_ODOO = (subscriptionId: number, creditId: number): string => {
    return (
      this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT +
      '/' +
      subscriptionId +
      '/credit/' +
      creditId +
      '/send-to-odoo'
    );
  };
  static get REST_API_GOVEXCREDIT_SEARCH(): string {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/credit/search';
  };

  // GovexRappel endpoints
  static REST_API_GOVEXRAPPEL_READ = (subscriptionId: number): string => {
    return this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + '/' + subscriptionId + '/rappel';
  };
  static REST_API_GOVEXRAPPEL_DOWNLOAD_PDF = (subscriptionId: number, rappelId: number): string => {
    return (
      this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT +
      '/' +
      subscriptionId +
      '/rappel/' +
      rappelId +
      '/download-pdf'
    );
  };
  static REST_API_GOVEXRAPPEL_VIEW_HTML = (subscriptionId: number, rappelId: number): string => {
    return (
      this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT +
      '/' +
      subscriptionId +
      '/rappel/' +
      rappelId +
      '/view-html'
    );
  };

  static REST_API_GOVEXPROFILE_HAS_ACTIVE_PROFILE(memberId: number) {
    return this.REST_API_GOVEXPROFILE_ENDPOINT + '/user/' + memberId + '/has-active-profile';
  }

  // CPV codes (2008) for right sidebar
  static get REST_API_CPV_LIST(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/cpv';
  }

  // BDA lots editor (REGOBO-33)
  static REST_API_BDA_LOTS(bdaId: number): string {
    return `${this.APP_API_URL_BACKEND()}/v1/rest-api/bda-lot/bda/${bdaId}`;
  }

  // JOUE lots editor (REGOBO-34)
  static REST_API_JOUE_LOTS(joueId: number): string {
    return `${this.APP_API_URL_BACKEND()}/v1/rest-api/joue-lot/joue/${joueId}`;
  }

  // BDA contractor (one-time maintenance backfill)
  static get REST_API_BDA_CONTRACTOR_BACKFILL_COMPANY_ID(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-contractor/backfill-company-id';
  }

  // JOUE contractor (one-time maintenance backfill)
  static get REST_API_JOUE_CONTRACTOR_BACKFILL_COMPANY_ID(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-contractor/backfill-company-id';
  }

  // JOUE authority (one-time maintenance backfill)
  static get REST_API_JOUE_AUTHORITY_BACKFILL(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-authority/backfill';
  }

  // BDA detail (REGOBO-35) -- flat record + version timeline + paged BDA-mails.
  static get REST_API_BDA_DETAIL_ENDPOINT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-detail';
  }

  static REST_API_BDA_DETAIL(bdaId: number): string {
    return this.REST_API_BDA_DETAIL_ENDPOINT + '/' + bdaId;
  }

  static REST_API_BDA_DETAIL_VERSIONS(bdaId: number): string {
    return this.REST_API_BDA_DETAIL_ENDPOINT + '/' + bdaId + '/versions';
  }

  static REST_API_BDA_DETAIL_BDAMAILS(bdaId: number): string {
    return this.REST_API_BDA_DETAIL_ENDPOINT + '/' + bdaId + '/mails';
  }

  // JOUE detail (REGOBO-36) -- flat record + JOUE mails.
  static get REST_API_JOUE_DETAIL_ENDPOINT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-detail';
  }

  static REST_API_JOUE_DETAIL(joueId: number): string {
    return this.REST_API_JOUE_DETAIL_ENDPOINT + '/' + joueId;
  }

  static REST_API_JOUE_DETAIL_MAILS(joueId: number): string {
    return this.REST_API_JOUE_DETAIL_ENDPOINT + '/' + joueId + '/mails';
  }

  // JOUE search (REGOBO-38) -- replaces legacy bo_joue_searchform.
  static REST_API_JOUE_SEARCH_SEARCH(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-search/search';
  }

  // BDA search (REGOBO-37) -- replaces legacy bo_bda_searchform.
  static REST_API_BDA_SEARCH_SEARCH(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-search/search';
  }

  // BDA upload (REGOBO-45) -- replaces legacy prepare_bda_file / prepare_bda2023_file / prepare_bda2023_or_file.
  // 3 form flows (classic / 2023 / 2023 OR), each with a "last 10 files" list and a test + upload action.
  static REST_API_BDA_UPLOAD_LAST_FILES(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-upload/last-files';
  }

  // Note: these "test" (dry-run) paths use "/parse", not "/test" — SpringCore's
  // JwtAuthenticationFilter treats any URI ending in the literal "/test" segment as a public,
  // unauthenticated endpoint and skips JWT validation for it, which would make these calls
  // always fail @PreAuthorize (silently anonymous) regardless of the caller's authority.
  static REST_API_BDA_UPLOAD_TEST_CLASSIC(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-upload/bda/parse';
  }

  static REST_API_BDA_UPLOAD_UPLOAD_CLASSIC(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-upload/bda/upload';
  }

  static REST_API_BDA_UPLOAD_TEST_BDA2023(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-upload/bda2023/parse';
  }

  static REST_API_BDA_UPLOAD_UPLOAD_BDA2023(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-upload/bda2023/upload';
  }

  static REST_API_BDA_UPLOAD_TEST_BDA2023_OR(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-upload/bda2023-or/parse';
  }

  static REST_API_BDA_UPLOAD_UPLOAD_BDA2023_OR(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-upload/bda2023-or/upload';
  }

  // BDA mail (read-only last-sent + detail, REGOBO-45 §1/§5) -- replaces legacy init_bdamail / view_bdamail.
  static REST_API_BDA_MAIL_LAST_SENT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-mail/last-sent';
  }

  static REST_API_BDA_MAIL_DETAIL(mailId: number): string {
    return this.APP_API_URL_BACKEND() + `/v1/rest-api/bda-mail/${mailId}`;
  }

  // JOUE upload (BOB-245) -- replaces legacy prepare_joue_file (zip + FTP) and prepare_tnl_file.
  // 2 form flows (JOUE = zip file / FTP download; TNL = fetch by daysAgo), each with a
  // "last 10 files" list and a test + upload action. Same "/parse" not "/test" convention as BDA:
  // SpringCore's JwtAuthenticationFilter treats a trailing "/test" segment as a public,
  // unauthenticated endpoint, which would silently bypass JWT and fail @PreAuthorize.
  static REST_API_JOUE_UPLOAD_LAST_FILES(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-upload/last-files';
  }

  static REST_API_JOUE_UPLOAD_TEST_FILE(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-upload/joue/file/parse';
  }

  static REST_API_JOUE_UPLOAD_UPLOAD_FILE(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-upload/joue/file/upload';
  }

  static REST_API_JOUE_UPLOAD_TEST_FTP(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-upload/joue/ftp/parse';
  }

  static REST_API_JOUE_UPLOAD_UPLOAD_FTP(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-upload/joue/ftp/upload';
  }

  static REST_API_JOUE_UPLOAD_TEST_TNL(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-upload/tnl/parse';
  }

  static REST_API_JOUE_UPLOAD_UPLOAD_TNL(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-upload/tnl/upload';
  }

  // JOUE mail (BOB-245, read-only last-sent + detail) -- replaces legacy init_jouemail / view_jouemail.
  static REST_API_JOUE_MAIL_LAST_SENT(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-mail/last-sent';
  }

  static REST_API_JOUE_MAIL_DETAIL(mailId: number): string {
    return this.APP_API_URL_BACKEND() + `/v1/rest-api/joue-mail/${mailId}`;
  }

  // BDA import errors (REGOBO-39) -- replaces legacy bo_bda_errors_search (BdaErrorListEventListener).
  static REST_API_BDA_ERROR_SEARCH_SEARCH(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-error-search/search';
  }

  // JOUE import errors (REGOBO-39) -- replaces legacy bo_joue_errors_search (JoueErrorListEventListener).
  static REST_API_JOUE_ERROR_SEARCH_SEARCH(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-error-search/search';
  }

  // Recent mail errors (REGOBO-42) -- replaces legacy GovexBackoffice /recent_mail_errors (BDA + JOUE).
  static REST_API_BDA_MAIL_ERRORS_SEARCH(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/bda-mail-errors/search';
  }

  static REST_API_JOUE_MAIL_ERRORS_SEARCH(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/joue-mail-errors/search';
  }

  // Govex reminders list (REGOBO-40) -- replaces legacy list_reminder.jsp + govex_rappels_quicklink.jsp.
  static REST_API_RAPPEL_SEARCH_SEARCH(): string {
    return this.APP_API_URL_BACKEND() + '/v1/rest-api/rappel-search/search';
  }
}
